import { ThemeProvider } from "@mui/material/styles"
import { theme } from "../../utils/theme"
import Header from "@components/Header/Header"

const SettingsDeprecation = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="bg-[#F7F7F7] relative h-screen">
        <Header />
        <div className="flex items-center justify-center h-full max-w-sm mx-auto px-4">
          <p className="text-center text-sm font-semibold text-gray-500">
            This page is deprecated. Use the new application instead.{" "}
            <a
              href="https://v3.getsoma.ai/meta/settings"
              className="text-blue-600 underline cursor-pointer"
            >
              Go to Settings
            </a>
          </p>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default SettingsDeprecation
